import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="bg-dark text-white pb-5">
      <div className="d-lg-flex d-block gap-4 container px-3 py-5 ">
        <div className="w-100">
          <h3 className="mb-4">COMPANY</h3>
          <p className="text-white-50">
          Let’s Work Together!
We’re here to provide tailored solutions to meet your business needs. Contact us today for inquiries, partnerships, or to learn more about our products and services.

          </p>
          <div className="mt-4"></div>
        </div>
        <div className="w-100 mt-lg-0 mt-5">
          <h3 className="mb-4">CONTACT</h3>
          <div className="d-sm-flex d-none">
            <div className="w-25">
              <p className="fw-semibold">Phone</p>
              <p className="fw-semibold">Email</p>
              <p className="fw-semibold">Address </p>
            </div>
            <div className="w-100">
              <p>+964-750-472-2395</p>
              <p>info@ganjtrading.com</p>
              <p>Qazi Mohammad Road, Duhok, Kurdistan Region of Iraq</p>
            </div>
          </div>
          <div className="d-sm-none d-block">
            <div>
              <p className="mb-0 fw-semibold">Phone</p>
              <p>+964-750-472-2395</p>

              <p className="mb-0 fw-semibold">Email</p>
              <p>info@ganjtrading.com</p>

              <p className="mb-0 fw-semibold">Address</p>
              <p className="ms-2"> Qazi Mohammad Road, Duhok, Kurdistan Region of Iraq</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container d-md-flex d-block gap-4 ">
        <div className="w-100 mt-md-0 mt-3 d-flex justify-content-center">
          <p className="text-white-50 mb-0 ">@ 2024 Sermed Berwari</p>
        </div>
      </div>
    </div>
  );
}
